<template>
  <StatisticsCard :title="title" content-classes="pt-6">
    <template #content>
      <!-- Counter -->
      <vue-ellipse-progress
        v-if="showCounter"
        :progress="counterProgress"
        v-bind="COUNTER_OPTIONS"
        :color="CW_GRADIENT"
      >
        <template #legend-value>
          <span slot="legend-value">%</span>
        </template>
        <template #legend-caption>
          <p class="text-xs text-truegray-500 italic">
            {{ counter.count }} / {{ counter.cap }}
          </p>
        </template>
      </vue-ellipse-progress>
      <!-- /Counter -->

      <!-- No data slot -->
      <slot v-else name="no-content"> No {{ type }}! </slot>
      <!-- /No data slot -->

      <!-- Modal button -->
      <button
        v-if="modalName"
        class="btn btn-trans-black btn-cw-cd p-3 mt-6 mb-0 font-normal"
        @click="showModal"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          class="w-4 h-4 mr-1"
        >
          <path
            d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z"
          />
        </svg>
        Posts
      </button>
      <!-- /Modal button -->
    </template>
  </StatisticsCard>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import { defineComponent, computed } from 'vue'
import { useStore } from '../../../js/store/index.js'
import StatisticsCard from './StatisticsCard.vue'
import { VueEllipseProgress } from 'vue-ellipse-progress'

export default defineComponent({
  name: 'StatisticsCardCounter',

  components: {
    StatisticsCard,
    VueEllipseProgress,
  },

  props: {
    type: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    getter: {
      type: String,
      required: true,
    },

    modalName: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const store = useStore()
    const CW_GRADIENT = {
      radial: false,
      colors: [
        {
          color: '#6F36BC',
          offset: '0',
          opacity: '1',
        },
        {
          color: '#FF4778',
          offset: '100',
          opacity: '1',
        },
      ],
    }

    const COUNTER_OPTIONS = {
      'empty-color': '#F5F5F5',
      'size': 120,
      'thickness': 14,
      'empty-thickness': 14,
      'line-mode': 'normal',
      'animation': 'default 1500 250',
      'font-size': '1.25rem',
      'font-color': '#6F36BC',
    }

    const counter = computed(() => {
      return store.getters[props.getter]
    })

    const showCounter = computed(() => {
      return (
        // 0 is a valid number of posts you can have
        counter.value?.count !== null &&
        counter.value?.count !== undefined &&
        counter.value?.cap
      )
    })

    const counterProgress = computed(() => {
      return Math.round((counter.value?.count / counter.value?.cap) * 100)
    })

    const showModal = () => {
      EventBus.$emit('showModal', {
        action: props.modalName,
      })
    }

    return {
      CW_GRADIENT,
      COUNTER_OPTIONS,
      counter,
      showCounter,
      counterProgress,
      showModal,
    }
  },
})
</script>
